/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import SectorEnum from 'astro/enum/sector';

import PlanetSector from 'astro/server/sector/planet';
import PlatformSector from 'astro/server/sector/platform';


export default class
{
  constructor (parent, sectors)
  {
    this.collection = new Map();

    for (const cass of sectors.values())
    {
      this.collection.set(cass.id, this.__initializeSector__(cass, parent));
    }
  }


  __initializeSector__ (cass, parent)
  {
    switch (cass.type)
    {
      case SectorEnum.Planet:   return new PlanetSector(cass, parent);
      case SectorEnum.Platform: return new PlatformSector(cass, parent);
    }

    throw new Error('Unsupported sector type.');
  }


  install ()
  {
    for (const sector of this.collection.values())
    {
      sector.install();
    }
  }


  getOne (id)
  {
    return this.collection.get(id);
  }


  getAll ()
  {
    return this.collection.values();
  }


}
